import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';



import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';

@Injectable({ providedIn: 'root' })
export class app_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    public FootPrintPortalManager: FootPrintPortalManager_ShellService,
  ) {
    super(dialog, toastr);
  }

  public app: app_ShellService = this;


  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {


    let result = null;
    result = this.FootPrintPortalManager.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
